/* eslint-disable */
// @ts-nocheck

import { useContext, useEffect, useState } from 'react'
import { SubmitHandler, useFieldArray, useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'

import { TrashIcon } from '@heroicons/react/24/outline'

import ComboBox from '../../../components/forms/Combobox'
import AlertContainer from '../../../components/misc/AlertContainer'
import Button from '../../../components/misc/Button'
import Modal from '../../../components/misc/GenericModal'
import { BasicType, SelectInterface } from '../../../interfaces/InterfacesLocal'
import { OnlineClientInterface } from '../../../interfaces/ServerInterfaces'
import { useAppSelector } from '../../../store/hooks'
import { EditClientCtx } from './EditOnlineClientContainer'

interface EditSettingsClientComponent {
  client: OnlineClientInterface
  deleteClient: Function
  isFetching: boolean
  callback?: (client: OnlineClientInterface) => void
  // editClient: Function;
}

export const EditSettingsClient = ({
  deleteClient,
  client,
  callback,
  isFetching,
}: EditSettingsClientComponent) => {
  const { editClient } = useContext(EditClientCtx)
  const [deleteModal, setDeleteModal] = useState(false)
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const mainPath = pathname.split('/')[1]

  const { users } = useAppSelector((store) => store.nomenclator)

  const { control, handleSubmit, setValue } = useForm({ mode: 'onChange' })
  const selectManagedData: SelectInterface[] = [
    {
      id: null,
      name: 'Sin asignar',
    },
  ]
  const onSubmit: SubmitHandler<BasicType> = (data) => {
    editClient && editClient(client?.id, data)
  }

  if (users !== null && users !== undefined) {
    //Select asociated area data ---------------------------------------------------------------------
    users?.map((item) => {
      // users?.filter(user => user?.roles?.find(rol => verifiedRoles.includes(rol.code)))?.map((item) => {
      selectManagedData.push({
        name: `${item.username ?? ''}/ ${item.displayName ?? ''}`,
        id: item.id,
      })
    })
  }

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex h-[27.1rem] w-full gap-6">
          <div className="w-full overflow-hidden p-5">
            <ComboBox
              control={control}
              data={selectManagedData}
              defaultValue={client?.commercial?.id}
              label="Comercial asignado"
              name="commercialId"
            />
          </div>

          <div className="flex h-fit w-[10%] justify-end">
            <Button
              action={() => setDeleteModal(true)}
              color="red-500"
              icon={<TrashIcon className="h-5 text-red-500" />}
              outline
            />
          </div>
        </div>
        <div className="mt-3 flex justify-end">
          <Button color="slate-600" name="Actualizar" type="submit" />
        </div>
      </form>
      {deleteModal && (
        <Modal close={setDeleteModal} state={deleteModal}>
          <AlertContainer
            loading={isFetching}
            onAction={() =>
              deleteClient(
                client.id,
                mainPath === 'clients'
                  ? () => {
                      navigate('/clients/all')
                    }
                  : callback
              )
            }
            onCancel={setDeleteModal}
            text="Seguro que desea eliminar este cliente?"
            title={`Eliminar cliente: ${client.firstName}`}
          />
        </Modal>
      )}
    </div>
  )
}
